import React, { useState, useEffect, useContext } from 'react';
import { makeStyles, Grid, Tabs, Tab, CircularProgress } from '@material-ui/core';

import { FormattedMessage, injectIntl } from 'react-intl';

import Documentation from '../../../Documentation';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Identification from './components/Identification';
import { setCity } from 'app/store/slices/forms';
import { FormServiceContext } from 'app/utils/contexts';

import styles from './styles';
import notification from 'app/config/notification';
import AlertMessage from 'app/components/AlertMessage';
import SaveButton from 'app/components/SaveButton';
import FinalizeButton from 'app/components/FinalizeButton';
const useStyles = makeStyles(styles);

function InitialAccess(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    initialValues,
    validationSchema,
    validateOnSave,
    onSubmit,
    validateForm,
    loadingDocuments,
    onSave,
    onCancel,
    mainColor,
    hideActionBtn,
    hideFinalizeBtn,
    isInternalForm,
    canEdit,
  } = useContext(FormServiceContext);

  const viewsIdentification = 0;
  const viewsDocumentation = 1;

  const [view, setView] = useState(viewsIdentification);

  const city = useSelector(state => state.forms.city);

  useEffect(() => {
    let temp = { ...city };
    if (initialValues.municipio) {
      initialValues.uf = initialValues.municipio.uf?.sgUf;
      temp = initialValues.municipio;
    }
    dispatch(setCity(temp));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleViewChange = (event, value) => {
    setView(value);
  };

  const renderTabs = () => {
    return (
      <Grid container spacing={3} className={classes.tabsContainer}>
        <Tabs
          variant="scrollable"
          className={classes.tabs}
          value={view}
          onChange={handleViewChange}
          indicatorColor={mainColor ? mainColor : 'primary'}
          textColor={mainColor ? mainColor : 'primary'}
        >
          <Tab
            className={classes.tab}
            label={<FormattedMessage id="LABELS.MENU.TABS.IDENTIFICATION" />}
          />
          {loadingDocuments && !isInternalForm && (
            <Tab
              className={classes.tab}
              label={<CircularProgress size={12} className={classes.loading} />}
            />
          )}
          {!isInternalForm && !loadingDocuments && (
            <Tab
              className={classes.tab}
              label={<FormattedMessage id="LABELS.COMMONS.DOCUMENTATION" />}
            />
          )}
        </Tabs>
      </Grid>
    );
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues ? initialValues : {}}
      validationSchema={validationSchema}
      // validateOnBlur={false}
      // validateOnChange={false}
      onSubmit={async values => {
        await onSubmit(values);
      }}
    >
      {props => {
        return (
          <Form className={classes.containerForm}>
            {renderTabs()}

            <AlertMessage isInternalForm={isInternalForm} />

            <>
              {view === viewsIdentification && <Identification {...props} />}
              {view === viewsDocumentation && <Documentation {...props} />}
            </>

            <SaveButton
              mainColor={mainColor}
              hideActionBtn={hideActionBtn}
              isInternalForm={isInternalForm}
              canEdit={canEdit}
              onCancel={() => onCancel(props.values)}
              onSave={() => {
                if (validateOnSave) {
                  props.validateForm().then(res => {
                    if (Object.keys(res).length <= 0) onSave(props.values);
                    else {
                      notification('O(s) campo(s) sinalizado(s) precisam de revisão.', {
                        toastId: 'VALIDATION',
                        type: 'error',
                      });
                    }
                  });
                } else {
                  onSave(props.values);
                }
              }}
            />

            <FinalizeButton
              mainColor={mainColor}
              hideFinalizeBtn={hideFinalizeBtn}
              isInternalForm={isInternalForm}
              canEdit={canEdit}
              onSubmit={() => {
                validateForm && validateForm(props.validateForm());
              }}
            />
          </Form>
        );
      }}
    </Formik>
  );
}

export default injectIntl(InitialAccess);
